var root = require("./_root");
var now = function() {
  return root.Date.now();
};
module.exports = now;
